// ----------------------------------------------------------------------

export type Props = {
  staggerOut?: number;
  staggerIn?: number;
  delayIn?: number;
};

export const varContainer = (props?: Props) => {
  const staggerIn = props?.staggerIn || 0.05;
  const delayIn = props?.staggerIn || 0.05;
  const staggerOut = props?.staggerIn || 0.05;

  return {
    animate: {
      transition: {
        delayChildren: delayIn,
        staggerChildren: staggerIn,
      },
    },
    exit: {
      transition: {
        staggerChildren: staggerOut,
        staggerDirection: -1,
      },
    },
  };
};
